import { __extends, __assign } from 'tslib';
import React__default from 'react';
import { IconPhoto } from '@tabler/icons';
import ButtonBase from '../ButtonBase/ButtonBase.component.js';
import Slider from '../Slider/Slider.component.js';
import colors from '../../util/colors.js';
import { zoomControlPropTypes, zoomControlDefaultProps } from './ImageCropper.types.js';
import styles from './ImageCropper.module.scss.js';

var ZoomControl = /** @class */ (function (_super) {
    __extends(ZoomControl, _super);
    function ZoomControl() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleSliderOnChange = function (event) {
            var onChange = _this.props.onChange;
            var target = event.target;
            onChange(parseFloat(target.value));
        };
        _this.handleZoomIn = function () {
            var _a = _this.props, maxZoom = _a.maxZoom, zoom = _a.zoom, onChange = _a.onChange;
            var newZoom = zoom + 0.5;
            onChange(Math.min(maxZoom, newZoom));
        };
        _this.handleZoomOut = function () {
            var _a = _this.props, minZoom = _a.minZoom, zoom = _a.zoom, onChange = _a.onChange;
            var newZoom = zoom - 0.5;
            onChange(Math.max(minZoom, newZoom));
        };
        return _this;
    }
    ZoomControl.prototype.render = function () {
        var _a = this.props, minZoom = _a.minZoom, maxZoom = _a.maxZoom, zoom = _a.zoom;
        /*
        A temporary solution to reduce the bundle,
        after fixing the Icon component,
        uncomment IconButton and remove inline svg with ButtonBase
        */
        var leftLabel = (React__default.createElement(ButtonBase, { onClick: this.handleZoomOut, type: "button", tabIndex: -1, "data-testid": 'close-button', style: {
                border: 'none',
                backgroundColor: 'transparent',
                cursor: 'pointer',
                width: '2.75rem',
                height: '2.75rem',
                paddingTop: '0.3rem',
            }, title: "Decrease zoom" },
            React__default.createElement(IconPhoto, { color: colors.white, size: 16 })));
        var rightLabel = (React__default.createElement(ButtonBase, { onClick: this.handleZoomIn, type: "button", tabIndex: -1, "data-testid": 'close-button', style: {
                border: 'none',
                backgroundColor: 'transparent',
                cursor: 'pointer',
                width: '2.75rem',
                height: '2.75rem',
                paddingTop: '0.3rem',
            }, title: "Increase zoom" },
            React__default.createElement(IconPhoto, { color: colors.white, size: 24 })));
        return (React__default.createElement("div", { className: styles.ZoomControl },
            React__default.createElement(Slider, { value: zoom, min: minZoom, max: maxZoom, step: 0.05, onChange: this.handleSliderOnChange, className: styles.ZoomControl_slider, leftLabel: leftLabel, rightLabel: rightLabel })));
    };
    ZoomControl.propTypes = zoomControlPropTypes;
    ZoomControl.defaultProps = __assign({}, zoomControlDefaultProps);
    ZoomControl.displayName = 'ZoomControl';
    return ZoomControl;
}(React__default.Component));

export { ZoomControl as default };
